import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import theme from '../../theme';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const FAQS = [
  {
    q: 'How fast does GA4 data land in BigQuery?',
    a: "It streams in realtime.",
  },
  {
    q: 'What does "parsing the nested data" actually mean?',
    a: "GA4's export nests event parameters and user properties inside repeated records. We flatten and aggregate all of that into standard tables you can query directly, without unpacking JSON by hand.",
  },
  {
    q: 'How is LTV calculated?',
    a: "You provide exports of customer lifetime values and we map those to GA4 and Adserver interactions.",
  },
  {
    q: 'Do I need to change my GA4 setup?',
    a: 'The minimum requirement would be user_id populated on all pageviews.',
  },
];

export default function GA4FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <View
      style={{
        paddingHorizontal: theme.spacing.space12,
        paddingTop: theme.spacing.space10,
        paddingBottom: theme.spacing.space16,
        maxWidth: 760,
        alignSelf: 'center',
        width: '100%',
        borderTopWidth: theme.borderWidth.thin,
        borderTopColor: theme.colors.borderSubtle,
      }}
    >
      <Text
        style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: theme.typography.size['2xl'],
          letterSpacing: theme.trackingPx(theme.typography.size['2xl'], 'tight'),
          color: theme.colors.textPrimary,
          marginBottom: theme.spacing.space6,
        }}
      >
        FAQ
      </Text>

      {FAQS.map((item, i) => {
        const isOpen = i === openIndex;
        return (
          <Pressable
            key={item.q}
            onPress={() => setOpenIndex(isOpen ? -1 : i)}
            style={{
              borderBottomWidth: theme.borderWidth.thin,
              borderBottomColor: theme.colors.borderDefault,
              paddingVertical: theme.spacing.space4 + 2,
            }}
          >
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: theme.spacing.space4 }}>
              <Text
                style={{
                  flex: 1,
                  fontFamily: theme.typography.fontBody,
                  fontWeight: theme.typography.weight.medium,
                  fontSize: theme.typography.size.base,
                  color: theme.colors.textPrimary,
                }}
              >
                {item.q}
              </Text>
              {isOpen ? (
                <RemoveIcon style={{ fontSize: 18, color: theme.colors.textTertiary, flexShrink: 0 }} />
              ) : (
                <AddIcon style={{ fontSize: 18, color: theme.colors.textTertiary, flexShrink: 0 }} />
              )}
            </View>
            {isOpen && (
              <Text
                style={{
                  fontFamily: theme.typography.fontBody,
                  fontSize: theme.typography.size.sm,
                  color: theme.colors.textSecondary,
                  lineHeight: theme.lineHeightPx(theme.typography.size.sm, 'normal'),
                  marginTop: theme.spacing.space3,
                  maxWidth: 620,
                }}
              >
                {item.a}
              </Text>
            )}
          </Pressable>
        );
      })}
    </View>
  );
}
